<template>
  <div v-if="showAnimation" id="trays-container">
    <div class="tray" v-for="n in totalTrays" :key="n" :style="{ animationDelay: `${n * 0.1}s` }"></div>
    <img src="images/intro/intro_1.png" class="tray tray-1" />
    <img src="images/intro/intro_2.png" class="tray tray-2" />
  </div>
</template>




<style>
#trays-container {
    position: relative;
    overflow: hidden;
}
.tray {
  width: 20vw;
  height: auto;
  opacity: 0;
  position: absolute;
  z-index: 1000;
}
.tray-1 {
  animation: fadeInOut-1 4s ease-in-out forwards;
  top: 0;
  left: 0;
}
.tray-2 {
  width: 20vw;
  height: auto;
  opacity: 0;
  animation: fadeInOut-1 4s ease-in-out forwards;
  position: absolute;
  top: 0;
  left: 0;
}
@keyframes fadeInOut-1 {
  0%, 55% { opacity: 0; }
  5%, 50% { opacity: 1; }
}
@keyframes fadeInOut-1 {
  5%, 60% { opacity: 0; }
  10%, 55% { opacity: 1; }
}

.home-overlay {
    position: fixed; /* Fixed position to cover the whole screen */
    top: 0;
    left: 0;
    width: 100vw; /* Full viewport width */
    height: 100vh; /* Full viewport height */
    background-color: white; /* White background */
    z-index: 20; /* Higher z-index to be on top of other elements */
    opacity: 0; /* Start with opacity 0 */
    animation: fadeIn 1s ease forwards 0.5s;
}
#trays-container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
}
.inactive-trays-container {
  z-index: auto; /* Or a lower value that doesn't interfere with other elements */
}

@keyframes fadeOutBackground {
  to {
    opacity: 0; /* Fade to transparent */
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>